import { defineComponent } from 'vue';

export default defineComponent({
  delimiters: ['${', '}'],
  props: {
    stockist: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data(props: any) {
    return {
      opened: props.initOpen,
    };
  },
  methods: {
    toggle() {
      this.opened = !this.opened;
    },
  },
  template: '#t-stockists-accordion',
});
